"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ramda = require("ramda");

var _styles = require("@qc-modules/styles");

var _propTypes = require("prop-types");

var _styledSystem = require("styled-system");

var _utils = require("../../utils");

var _excluded = ["fieldId", "handleBlur", "handleChange", "handleFocus", "hasLabel", "isValid", "options", "pattern", "required", "showValue"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var BasicSelect = _styledComponents["default"].select.withConfig({
  displayName: "select__BasicSelect",
  componentId: "sc-1oz3hm8-0"
})(["background:transparent;border:none;font-family:inherit;height:auto;outline:none;transform:", ";transform-origin:0 0;", ";", ";appearance:none;&::placeholder{color:", ";}padding-right:40px;"], function (_ref) {
  var showLabel = _ref.showLabel;
  return "translate3d(0, " + (showLabel ? "7px" : "0") + ", 0)";
}, (0, _styles.transitionEase)("0.3s", ["transform"]), (0, _styledSystem.compose)(_styledSystem.color, _styledSystem.opacity, _styledSystem.space, _styledSystem.typography, _styledSystem.width), function (props) {
  return (0, _styles.colors)("placeholder", props);
});

var propTypes = {
  // Passwed id of select
  fieldId: _propTypes.string,
  // callback to handler blur event
  handleBlur: _propTypes.func,
  // callback to handler change event
  handleChange: _propTypes.func,
  // callback to handler focus event
  handleFocus: _propTypes.func,
  // Label show/hide control
  hasLabel: _propTypes.bool,
  // callback to handler blur event
  isValid: _propTypes.bool,
  // Select options
  options: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]).isRequired,
    label: _propTypes.string,
    value: _propTypes.string
  })), (0, _propTypes.arrayOf)(_propTypes.string), (0, _propTypes.arrayOf)(_propTypes.number)]),
  // Validate pattern
  pattern: _propTypes.string,
  // Control selection is required or not
  required: _propTypes.bool,
  // Enable Show/hide selected value along with showLabel
  showValue: (0, _propTypes.oneOfType)([_propTypes.bool, _propTypes.string])
};

var Select = function Select(_ref2) {
  var fieldId = _ref2.fieldId,
      handleBlur = _ref2.handleBlur,
      handleChange = _ref2.handleChange,
      handleFocus = _ref2.handleFocus,
      hasLabel = _ref2.hasLabel,
      isValid = _ref2.isValid,
      options = _ref2.options,
      pattern = _ref2.pattern,
      required = _ref2.required,
      showValue = _ref2.showValue,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded);

  return /*#__PURE__*/_react["default"].createElement(BasicSelect, _extends({
    id: fieldId
  }, _utils.defaultFontSize, _utils.defaultSpacing, {
    color: "text-title",
    fontWeight: 1,
    onBlur: handleBlur,
    onChange: handleChange,
    onFocus: handleFocus,
    opacity: !hasLabel || showValue ? 1 : 0,
    pattern: pattern,
    showLabel: showValue && hasLabel,
    width: 1
  }, props), options.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: option.value + "-" + option.id,
      value: !(0, _ramda.isNil)(option.value) ? option.value : option
    }, !(0, _ramda.isNil)(option.label) ? option.label : option);
  }));
};

Select.propTypes = propTypes;
var _default = Select;
exports["default"] = _default;